export default {
  LIST(state, data) {
    state.posts = data
  },
  UPDATE(state, value) {
    state.post = {
      ...value,
    }
  },
  FRESH(state) {
    state.post = {
      id: null,
      title_uz: '',
      title_ru: '',
      title_en: '',
      body_uz: '',
      body_ru: '',
      body_en: '',
      image: null,
      status: null,
    }
  },
  GET(state, value) {
    state.post = {
      ...value,
    }
  },
}
